import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberRansomware = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M4.92 3.87A2.235 2.235 0 0 0 2.69 6.1v37.17h58.63V6.1a2.235 2.235 0 0 0-2.23-2.23zm54.17-2a4.235 4.235 0 0 1 4.23 4.23v38.17a1 1 0 0 1-1 1H1.69a1 1 0 0 1-1-1V6.1a4.235 4.235 0 0 1 4.22-4.23z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 9.29a5.68 5.68 0 0 0-5.68 5.68v4.67a1 1 0 1 1-2 0v-4.67A7.68 7.68 0 0 1 32 7.29a7.68 7.68 0 0 1 7.68 7.68v4.67a1 1 0 1 1-2 0v-4.67A5.68 5.68 0 0 0 32 9.29",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M19.7 20.37a1 1 0 0 1 1-1h22.6a1 1 0 0 1 1 1v18.96a1 1 0 0 1-1 1H20.7a1 1 0 0 1-1-1zm2 1v16.96h20.6V21.37zM.68 44.27a1 1 0 0 1 1-1h60.64a1 1 0 0 1 1 1v4.18a4.35 4.35 0 0 1-4.35 4.35H5.03a4.35 4.35 0 0 1-4.35-4.35zm2 1v3.18a2.35 2.35 0 0 0 2.35 2.35h53.94a2.35 2.35 0 0 0 2.35-2.35v-3.18z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M23.112 51.581a1 1 0 0 1 .978-.791h15.82a1 1 0 0 1 .978.791l1.4 6.55a1 1 0 0 1-.978 1.209H22.69a1 1 0 0 1-.978-1.209zM24.9 52.79l-.973 4.55h16.148l-.973-4.55zM10.37 26.77a1.7 1.7 0 0 0-1.7 1.7v2.02a1.7 1.7 0 0 0 1.7 1.7h3.37a1.7 1.7 0 0 0 1.7-1.7v-2.02a1.7 1.7 0 0 0-1.7-1.7zm-3.7 1.7a3.7 3.7 0 0 1 3.7-3.7h3.37a3.7 3.7 0 0 1 3.7 3.7v2.02a3.7 3.7 0 0 1-3.7 3.7h-3.37a3.7 3.7 0 0 1-3.7-3.7z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M1.17 29.48a1 1 0 0 1 1-1h7.84a1 1 0 1 1 0 2H2.17a1 1 0 0 1-1-1m11.93 0a1 1 0 0 1 1-1h7.84a1 1 0 1 1 0 2H14.1a1 1 0 0 1-1-1m37.64-2.71a1.7 1.7 0 0 0-1.7 1.7v2.02a1.7 1.7 0 0 0 1.7 1.7h3.37a1.7 1.7 0 0 0 1.7-1.7v-2.02a1.7 1.7 0 0 0-1.7-1.7zm-3.7 1.7a3.7 3.7 0 0 1 3.7-3.7h3.37a3.7 3.7 0 0 1 3.7 3.7v2.02a3.7 3.7 0 0 1-3.7 3.7h-3.37a3.7 3.7 0 0 1-3.7-3.7z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M41.54 29.48a1 1 0 0 1 1-1h7.84a1 1 0 1 1 0 2h-7.84a1 1 0 0 1-1-1m11.94 0a1 1 0 0 1 1-1h7.84a1 1 0 1 1 0 2h-7.84a1 1 0 0 1-1-1m-25.05-1.99c0-2.087 1.72-3.35 3.57-3.35a3.574 3.574 0 0 1 3.516 2.972 1 1 0 1 1-1.972.336A1.574 1.574 0 0 0 32 26.14c-.99 0-1.57.597-1.57 1.35 0 .354.138.594.415.809.314.244.793.435 1.374.565.712.16 1.517.438 2.164.942.684.532 1.187 1.322 1.187 2.384 0 2.074-1.717 3.35-3.57 3.35a3.57 3.57 0 0 1-3.57-3.57 1 1 0 1 1 2 0c0 .868.702 1.57 1.57 1.57.987 0 1.57-.604 1.57-1.35 0-.348-.137-.589-.416-.806-.315-.246-.795-.439-1.373-.569-.71-.159-1.515-.433-2.163-.937-.686-.532-1.188-1.323-1.188-2.388",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 22.87a1 1 0 0 1 1 1v1.28a1 1 0 1 1-2 0v-1.28a1 1 0 0 1 1-1m0 10.69a1 1 0 0 1 1 1v1.28a1 1 0 1 1-2 0v-1.28a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberRansomware;
